import { Component, type ReactNode } from 'react';

// Last line of defence: a crash in one screen shows a reload button, not a blank page.
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: unknown) {
    console.error(error);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="mx-auto max-w-md p-8 text-center">
        <h1 className="text-xl font-bold">Kuna tatizo. / Something went wrong.</h1>
        <button className="btn btn-primary mt-4" onClick={() => location.reload()}>Pakia upya / Reload</button>
      </div>
    );
  }
}
